import type { ReactNode, ComponentProps } from "react";
import { motion } from "motion/react";
import type { Easing } from "motion/react";

const AnimateIn = ({
  children,
  delay = 0,
  duration = 0.1,
  ease,
  initial = {
    opacity: 0,
    transform: "translate3d(100%, 0, 0)",
  },
  animate = {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  exit = {
    opacity: 0,
    transform: "translate3d(100%, 0, 0)",
  },
}: {
  children: ReactNode;
  delay?: number;
  duration?: number;
  ease?: Easing | Easing[];
  initial?: ComponentProps<typeof motion.div>["initial"];
  animate?: ComponentProps<typeof motion.div>["animate"];
  exit?: ComponentProps<typeof motion.div>["exit"];
}) => {
  return (
    <motion.div
      initial={initial}
      animate={animate}
      exit={exit}
      transition={{ duration, delay, ease }}
    >
      {children}
    </motion.div>
  );
};

export { AnimateIn };
